import apiClient from "api";

export interface ProductFeature {
  name: string;
  description?: string;
  enabled: boolean;
}

export interface Product {
  id: number;
  product_id: string;
  name: string;
  description?: string;
  amount: string;
  currency: string;
  duration: string;
  stripeProductId: string | null;
  stripePriceId: string | null;
  features: ProductFeature[] | null;
  type: string;
  isPublic: boolean;
  tenant_id: string | null;
  need_user: boolean;
  created_at: string;
  updated_at: string;
}

export interface PurchaseInitRequest {
  product_id: string;
}

export const productsService = {
  async getProducts(): Promise<Product[]> {
    const response = await apiClient.get<Product[]>("/public/products");
    return response.data;
  },

  async getProductById(productId: string): Promise<Product> {
    const response = await apiClient.get<Product>(`/public/products/${productId}`);
    return response.data;
  },

  async initiatePurchase(productId: string): Promise<{ error?: string; redirect?: boolean; redirect_url?: string }> {
    try {
      
      const response = await apiClient.post(
        "/public/purchase/init",
        { 
          product_id: productId, 
          return_url: typeof window !== "undefined" ? window.location.origin : "" 
        },
        {
          withCredentials: true, 
        }
      );

      // Backend returns redirect_url in response
      return { 
        redirect: true,
        redirect_url: response.data?.redirect_url 
      };
    } catch (error: any) {
      console.error("Failed to initiate purchase:", error);
      
    
      if (error.response?.status === 400) {
        return {
          error: error.response?.data?.error || "Invalid product ID",
        };
      }
      
      return {
        error: error.response?.data?.error || "Failed to initiate purchase",
      };
    }
  },
};

